export const INDEX_FACTORS_AVAILABLE_FROM_YEAR = 1947;

export const GROUP = 'GROUP';
export const SUB_GROUP = 'SUB_GROUP';
export const ENTRY = 'ENTRY';

export const RowTypes = [GROUP, SUB_GROUP, ENTRY] as const;
export type RowType = (typeof RowTypes)[number];
